import React from 'react';
import Form from '@rjsf/core';
import CustomErrorList from './CustomErrorList';

type Props = {
  schema: any;
  uiSchema: any;
  formData?: any;
  readonly?: boolean;
};

const validator = (uiSchema: any) => (formData: any, errors: any) => {
  Object.keys(formData).forEach((key: string) => {
    if (uiSchema[key]) {
      const uiOptions = uiSchema[key]['ui:options'];
      if (uiOptions && uiOptions.maxRows) {
        const lines = formData[key].split(/\r\n|\r|\n/);
        if (lines.length > uiOptions.maxRows) {
          errors[key].addError(
            `${key} must be less than ${uiOptions.maxRows} lines`,
          );
        }
      }
    }
  });
  return errors;
};

const enhancedUiSchema = (uiSchema: any) => {
  return Object.fromEntries(
    Object.entries(uiSchema).map(([key, value]: [string, any]) => {
      let classNames = value.classNames || '';
      if (value['ui:widget'] === 'radio') {
        classNames += ' survey-form-radio';
      }
      if (value['ui:widget'] === 'checkboxes') {
        classNames += ' survey-form-checkbox';
      }
      return [
        key,
        {
          ...value,
          classNames: classNames.trim(),
        },
      ];
    })
  );
};

const errorMessages: Record<string, (params?: any, schemaProperty?: any) => string> = {
  required: (params, schemaProperty) => schemaProperty?.maxLength ? `回答（最大${schemaProperty?.maxLength}文字まで）を入力してください` : '回答を選択してください',
  maxLength: (params) => `回答（最大${ params?.limit}文字まで）を入力してください`,
  minItems: (params) => `回答（${params?.limit}つ以上）を選択してください`,
  maxItems: (params) => `回答（最大${params?.limit}つまで）を選択してください`,
};

const transformErrors = (errors: any[], schema: any) => {
  return errors.map((error) => {
    const getMessage = errorMessages[error.name];
    if (getMessage) {
      return {
        ...error,
        message: getMessage(error.params, schema.properties[error.params.missingProperty]),
      };
    }
    return error;
  });
};

export const SurveyPreview = ({
  schema,
  uiSchema,
  formData,
  readonly,
}: Props) => (
  <Form
    schema={schema}
    uiSchema={enhancedUiSchema(uiSchema)}
    formData={formData}
    validate={validator(uiSchema)}
    transformErrors={(errors: any[]) => transformErrors(errors, schema)}
    liveValidate={!readonly}
    readonly={readonly}
    className="rjsf rjsf-survey"
    ErrorList={CustomErrorList}
  >
    <div />
  </Form>
);
